module.exports = __webpack_public_path__ + "media/images/checkbox-unchecked-b7ad2203660af134691c998bc5f995f8.svg";